import scrollableSection from "../components/scrollableSection"

const Brand_Info1 = () =>{
    // In Brand info-page please add the double on sections number -> if 3 section please add 6 etc...
    // Need to pass ( if has slider in Mobile, and left section count of entire sections and Right section count of entire sections)
    scrollableSection(false,3,3);
}

export default Brand_Info1